<cac-dialog-layout
  [title]="data.banner ? 'Edit Banner' : 'Create New Banner'"
  subtitle="Enter the required data and save"
  (onSubmit)="onSubmit($event)"
>
  <cac-image-uploader [control]="image" [options]="options" class="h-44" />
  <cac-form-builder [options]="form" class="mt-5" />
</cac-dialog-layout>
